// ---------------------------------------------------------------------------
// Auth
// ---------------------------------------------------------------------------
export const user_logged_in = 'user_logged_in';
export const user_logged_out = 'user_logged_out';

// ---------------------------------------------------------------------------
// Class lifecycle
// Equivalent to lesson_open / lesson_close in ondemand.
// A class maps to a lesson; each material (recording, slides, etc.) maps to a page.
// ---------------------------------------------------------------------------
export const class_opened = 'class_opened';
export const class_closed = 'class_closed';
export const material_opened = 'material_opened';
export const material_closed = 'material_closed';

// ---------------------------------------------------------------------------
// Media (recording / video player)
// ---------------------------------------------------------------------------
export const media_play = 'media_play';
export const media_pause = 'media_pause';
export const media_seek = 'media_seek';
export const media_end = 'media_end';
export const media_replay = 'media_replay';
export const media_speed_changed = 'media_speed_changed';
export const media_window_hidden = 'media_window_hidden';
export const media_window_visible = 'media_window_visible';

// ---------------------------------------------------------------------------
// Assessment
// ---------------------------------------------------------------------------
export const assessment_started = 'assessment_started';
export const assessment_question_answered = 'assessment_question_answered';
export const assessment_answer_changed = 'assessment_answer_changed';
export const assessment_submitted = 'assessment_submitted';
export const assessment_timed_out = 'assessment_timed_out';
export const assessment_extension_requested = 'assessment_extension_requested';

// ---------------------------------------------------------------------------
// Coach panel
// ---------------------------------------------------------------------------
export const coach_opened = 'coach_opened';
export const coach_closed = 'coach_closed';

// ---------------------------------------------------------------------------
// Exercises
// ---------------------------------------------------------------------------
export const exercise_completed = 'exercise_completed';

// ---------------------------------------------------------------------------
// Tasks (What's Next panel)
// task_type values: class | assessment | poll | Survey | Live Session |
//                   Prep Material | Pre-Class Reflection | Apply at Work |
//                   Onboarding Session
// ---------------------------------------------------------------------------
export const task_opened = 'task_opened';

// ---------------------------------------------------------------------------
// Attendance poll (AttendancePoll.vue)
// ---------------------------------------------------------------------------
export const poll_opened = 'poll_opened';
export const poll_answer_changed = 'poll_answer_changed';
export const poll_submitted = 'poll_submitted';
export const poll_dismissed = 'poll_dismissed';

// ---------------------------------------------------------------------------
// Survey / feedback
// ---------------------------------------------------------------------------
export const survey_started = 'survey_started';
export const survey_submitted = 'survey_submitted';
export const survey_answer_changed = 'survey_answer_changed';
export const survey_abandoned = 'survey_abandoned';
export const survey_questions_dropped = 'survey_questions_dropped';

// ---------------------------------------------------------------------------
// App switcher ('Looking for OnDemand?')
// ---------------------------------------------------------------------------
export const app_switcher_used = 'app_switcher_used';

// ---------------------------------------------------------------------------
// Badges / certificates (Accredible)
// ---------------------------------------------------------------------------
export const badge_accessed = 'badge_accessed';

// ---------------------------------------------------------------------------
// FAQ
// ---------------------------------------------------------------------------
export const faq_opened = 'faq_opened';
export const faq_collapsed = 'faq_collapsed';
